var map = {
	"./de.json": [
		23063,
		"libs_shared_ui-discard-changes_src_i18n_de_json"
	],
	"./en.json": [
		63139
	],
	"./es.json": [
		89893,
		"libs_shared_ui-discard-changes_src_i18n_es_json"
	],
	"./et.json": [
		35164,
		"libs_shared_ui-discard-changes_src_i18n_et_json"
	],
	"./fr.json": [
		88085,
		"libs_shared_ui-discard-changes_src_i18n_fr_json"
	],
	"./it.json": [
		31344,
		"libs_shared_ui-discard-changes_src_i18n_it_json"
	],
	"./nl.json": [
		68011,
		"libs_shared_ui-discard-changes_src_i18n_nl_json"
	],
	"./pt.json": [
		71592,
		"libs_shared_ui-discard-changes_src_i18n_pt_json"
	],
	"./ru.json": [
		20280,
		"libs_shared_ui-discard-changes_src_i18n_ru_json"
	],
	"./sv.json": [
		74323,
		"libs_shared_ui-discard-changes_src_i18n_sv_json"
	],
	"./zh-CN.json": [
		78844,
		"libs_shared_ui-discard-changes_src_i18n_zh-CN_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98305;
module.exports = webpackAsyncContext;